"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitWorkspaceNameF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../actionCreators/createErrorAction");
var effects_1 = require("redux-saga/effects");
var selectState_1 = require("../../state/selectState");
var patchWorkspacesSaga_1 = require("../sagas/patch/patchWorkspacesSaga");
var takeGaurd_1 = require("../../utilities/takeGaurd");
var description = 'submitWorkspaceNameF';
var submitWorkspaceNameF = function () {
    var action, displayName, state, workspaceId, error_1;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!1) return [3 /*break*/, 12];
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('UPDATE_WORKSPACE_NAME_ACTION')];
            case 1:
                action = _b.sent();
                displayName = action.displayName;
                return [4 /*yield*/, (0, effects_1.select)(selectState_1.selectState)];
            case 2:
                state = _b.sent();
                workspaceId = state.currentWorkspaceId;
                if (!(displayName && workspaceId)) return [3 /*break*/, 9];
                _b.label = 3;
            case 3:
                _b.trys.push([3, 6, , 8]);
                return [4 /*yield*/, (0, effects_1.spawn)(patchWorkspacesSaga_1.patchWorkspacesSaga, {
                        items: (_a = {},
                            _a[workspaceId] = {
                                data: {
                                    displayName: displayName,
                                },
                            },
                            _a),
                    })];
            case 4:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'SET_ALERT_MESSAGE',
                        description: description,
                        values: {
                            location: 'toast',
                            type: 'success_check',
                            message: 'Updated',
                        },
                    })];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                        description: description,
                        error: error_1,
                    }))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
exports.submitWorkspaceNameF = submitWorkspaceNameF;
